__webpack_require__.p = "/games/_next/";